<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent :width="this.width">
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="date"
          :label="label"
          prepend-icon="mdi-calendar-outline"
          readonly
          v-bind="attrs"
          v-on="on"
        ></v-text-field>
      </template>
      <v-date-picker v-model="date" header-color="primary" first-day-of-week="1" show-current>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="cancel()">Cancel</v-btn>
        <v-btn text color="primary" @click="okay()">OK</v-btn>
      </v-date-picker>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  created() {},
  mounted() {},
  computed: {
    date: {
      get() {
        return this.value || this.$options.filters.date_only(new Date().toISOString());
      },
      set(date) {
        this.value = date;
      },
    },
  },
  methods: {
    okay() {
      this.$emit("input", this.date);
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
  },
  watch: {},
  props: {
    value: {
      type: String,
    },
    label: {
      type: String,
      default: "Please pick a date",
    },
    width: {
      type: [Number, String],
      default: 300,
    },
  },
};
</script>

<style lang="scss" scoped>
</style>